// Config for application roles
export const ROLES = {
  ADMIN: "admin",
  USER: "user",
};

// Config for role selection during user creation
export const rolesForUserMaster = [
  {
    label: "Admin",
    value: "admin"
  },
  {
    label: "User",
    value: "user"
  },
]


// Config to retrive a application role name
export const appRoleNameConfig = {
  "admin": "Admin",
  "user": "User",
}

export const getRelativeRoleName = (key) => {
  return appRoleNameConfig[key] || "Not Available";
};